export enum IntegrationAction {
  GET_STATUS = 'get airbnb integration status',
  GET_BOXBUY_STATUS = 'get boxbuy integration status',
  SetIntegration = 'set airbnb integration status',
  SetBoxBuyIntegration = 'set boxbuy integration status',
  SetBoxBuyLoading = 'SetBoxBuyLoading',
  CreateIntegration = 'create airbnb integration with account',
  CreateBoxBuyIntegration = 'create boxbuy integration with account',
  DisconnectBoxBuyIntegration = 'disconnect boxbuy integration with account',
  GetListings = 'get airbnb integration listings',
  AcceptListings = 'accept airbnb integration listings',
  SetTab = 'set airbnb integration tab',
  SetPriceTab = 'set airbnb price tab tab',
  DeleteListing = 'delete airbnb integration listings',
  CreateListing = 'create airbnb integration listings',
  AcceptCreateListing = 'Accept create airbnb integration listings',
  SetSync = 'set airbnb sync status',
  ToggleSync = 'toggle airbnb sync status',
  AcceptDeleteListing = 'Accept delete airbnb listing',
  RequestPrices = 'request airbnb prices',
  ToggleNotAllModal = 'toggle airbnb not all connected modal',
  AcceptFetchPrice = 'Accept airbnb rooms prices',
  SubmitPriceForm = 'Submit airbnb rooms prices',
  SetLoadingPrice = 'set airbnb prices loading',
  FetchRoomConfiguration = 'get airbnb room configuration',
  RoomConfigurationAccepted = 'set airbnb room configuration',
  SaveRoomConfiguration = 'save airbnb room configuration',
  ToggleConfigurationLoading = 'toggle airbnb room configuration loading',
  ToggleSavingConfiguration = 'toggle saving airbnb room configuration',
  SetICalToken = 'set icalendar token',
  FetchICalSettings = 'fetch icalendar settings',
  SetIcalSettings = 'set icalendar settings',
  FixIcalSync = 'fix icalendar settings',
  UpdateICalSettings = 'update icalendar settings',
  SetPropertyId = 'set booking property id',
  SetPropertyIdRedux = 'set booking property id in redux',
  SetBookingStatus = 'set booking status',
  SetBookingStatusRedux = 'set booking status in redux',
  FetchBookingSettings = 'get booking integration settings',
  SetBookingSettingsRedux = 'set booking integration settings in redux',
  FetchBookingRooms = 'get booking integration rooms',
  SetBookingRoomsRedux = 'set booking integration rooms in redux',
  BookingDeleteMapping = 'booking delete mapping redux',
  BookingSaveMappedRooms = 'booking save mapping rooms redux',
  BookingDeletePricing = 'booking delete pricing redux',
  BookingSavePriceConfiguration = 'booking save pricing configuration redux',
  BookingSaveConfiguration = 'booking save configuration',
  BookingStartRoomSync = 'booking start room syncing',
  SetBookingStep = 'set booking step redux',
  ConfirmBookingConfiguration = 'confirm booking configuration',
  UnconfirmBookingConfiguration = 'unconfirm booking configuration',
  SetBookingChanged = 'set booking changed',
  SetBookingErrorRooms = 'set booking error rooms',
  SetTrobuledBookingRooms = 'set booking troubled rooms',
  SetBookingStartRoomSync = 'set booking sync rooms rooms',
  SetBookingPricingInfo = 'set booking pricing info',
  SetBookingTab = 'set booking tab',
  SetIcalSaving = 'set ical saving',
  CreateInvoiceService = 'create invoice service',
  CreateOrOpenInvoice = 'create or open invoice service',
  SetAirbnbAgreement = 'set airbnb agreement',
  SetAirbnbBackdrop = 'set airbnb backdrop',
  BookingConnect = 'create new booking connection',
  ChangeBookingName = 'change booking name',
  BookingDeleteProperty = 'delete booking property',
  CheckBookingProperty = 'check booking property',
  SetBookingPropertyModalStep = 'set booking property modal step',
  SetBookingPropertyModalConfirmStep = 'set booking property modal confirm step',
  ToggleBookingPropertyConfirmModal = 'toogle booking property confirm modal',
  SetBookingPropertyValueTaken = 'set booking property value taken',
  SetBookingPropertyCheckLoading = 'set booking property check loading',
  BookingSaveMappedRoomsImport = 'booking save mapping rooms import redux',
  StartConfirmingProperty = 'start confirming property booking',
  MergeBookingPlanRates = 'merge booking plan rates after price grid new plan flow',
}
